<cas-button color="accent"
            btnText="Deactivate"
            (clickAction)="deactivate()"
            *ngIf="isActive()"></cas-button>
            